import { useState, useCallback } from "react";

const INITIAL_PARAMS = {
  campaignId: null,
  paymentType: null,
  yearMonth: null,
  currentPage: 1,
  pageSize: 10
};

/**
 * Hook para manejar la lógica de filtros del historial de pagos.
 * Centraliza el estado de filtros, paginación y limpieza.
 */
export const usePaymentHistoryFilters = () => {
  const [params, setParams] = useState({ ...INITIAL_PARAMS });
  const [isClearFilter, setClearFilter] = useState(false);

  const onFilter = useCallback(
    ({ campaignId, paymentType, yearMonth }) => {
      const updatedParams = {
        ...params,
        campaignId: campaignId || null,
        paymentType: paymentType || null,
        yearMonth: yearMonth || null,
        currentPage: 1
      };
      setParams(updatedParams);
      return updatedParams;
    },
    [params]
  );

  const cleanFilters = useCallback(() => {
    setClearFilter(true);
    setParams({ ...INITIAL_PARAMS });
    return { ...INITIAL_PARAMS };
  }, []);

  const resetClearFlag = useCallback(() => {
    setClearFilter(false);
  }, []);

  const setPage = useCallback((page) => {
    setParams((prev) => ({
      ...prev,
      currentPage: page
    }));
  }, []);

  const setPageSize = useCallback((size) => {
    setParams((prev) => ({
      ...prev,
      pageSize: size,
      currentPage: 1
    }));
  }, []);

  return {
    params,
    isClearFilter,
    onFilter,
    cleanFilters,
    resetClearFlag,
    setPage,
    setPageSize
  };
};
